/**
 * 患者のログインの画面に出す手引き（案内 SMS の手引きと同じ URL。Q49）。
 * scripts/generate_frontend2_env.sh が SSM の /sas/{stage}/sms/onboarding/manual-url を読んで VITE_PATIENT_MANUAL_URL に書く。
 * 空か http(s) で始まらない値なら null（画面に出さない）。
 */
export function patientManualUrl(): string | null {
  const value = import.meta.env.VITE_PATIENT_MANUAL_URL;
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : null;
}
